export default __webpack_public_path__ + "static/media/star.9484526d.gif";